module.exports = __webpack_public_path__ + "img/4c90287.jpg";